import { createLivePreviewRequestHandler } from "src/utils/livePreviewHandler";

/**
 * Live preview request handler for `poker-carousel` (no drafts on this collection).
 */
export const pokerCarouselLivePreviewRequestHandler = createLivePreviewRequestHandler(
  ({ serverURL, apiPath, docId }) =>
    `${serverURL}${apiPath}/poker-carousel/${docId}?depth=0`
);
